import React, {useEffect} from 'react';
import styled from "styled-components";
import {Link} from "react-router-dom";
import {HelmetProvider} from 'react-helmet-async'
import BannerTextAnimated from "../../components/home/BannerTextAnimated";
import Banner from "../../components/home/Banner";
import Seo from "../../components/Seo";

const MyComponent = () => {
    return (
        <HelmetProvider>
            <Seo
                title="Animation test | UCC"
                description="UCC animation playground page."
                noIndex
            />

            <StyledComponent>
                <BannerTextAnimated/>
            </StyledComponent>
        </HelmetProvider>
    );
};

const StyledComponent = styled.section`

`;

export default MyComponent;
